var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"expande-horizontal centraliza",staticStyle:{"height":"100vh"}},[_c('v-icon',{staticClass:"mr-2",attrs:{"color":_vm.$theme.primary,"size":"50"}},[_vm._v("mdi-account-circle")]),_c('h4',{staticClass:"text-center fonte orange--text"},[_vm._v(" Ativando conta... ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }